import React from 'react';

import User from './User';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

const UserList = (props) => {

	function removeUser(index) {
		props.removeU(index);
	}

	return (
		<Card>	        

			<CardContent className="home">

	          <Typography gutterBottom variant="h4" component="div">
	            Users
	          </Typography>

	        {props.ul.map((u,i) => 

	            <User u={u} i={i} key={i} 
	            removeUserHandler={removeUser} />

	        )}

	        </CardContent>

	        </Card>
	)
}

export default UserList